module.exports = __webpack_public_path__ + "static/media/ic_car-white.918abce2.svg";